import * as React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Service Worker completely disabled for development
if ('serviceWorker' in navigator) {
  // Force unregister all existing service workers
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      console.log('Unregistering service worker:', registration.scope);
      registration.unregister();
    });
  });
}

// Add error boundary and logging
console.log('Main.tsx: Starting React app...');

try {
  const rootElement = document.getElementById("root");
  console.log('Main.tsx: Root element found:', rootElement);
  
  if (!rootElement) {
    throw new Error('Root element not found!');
  }
  
  const root = createRoot(rootElement);
  console.log('Main.tsx: React root created');
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
  console.log('Main.tsx: React app rendered successfully');
} catch (error) {
  console.error('Main.tsx: Error rendering React app:', error);
  document.getElementById("root")!.innerHTML = `
    <div style="padding: 20px; color: red;">
      <h1>Error Loading App</h1>
      <p>${error.message}</p>
      <p>Check console for details.</p>
    </div>
  `;
};
